export const COURSE_ACTIONS = {
    COURSE_LIST : "COURSE_LIST"
}